<template>
    <div class=" form_upload">
        <v-modal-contents ref="modal_contents_agree">

            <template v-slot:close>
                <!--        убираем close-->
                <div></div>
            </template>

            <template v-slot:title>

                <div class="terms_of_use__title mt-30 pl-3 ">
                    <div class="h2_title">Условия использования персональных данных</div>

                </div>

            </template>
            <template v-slot:content>
                <div class="terms_of_use mt-30 ">
                    <div v-html="terms"></div>
                    <div class="mt-30">
                        <button class="px-30 btn_bordered "
                                @click="$refs.modal_contents_agree.modal_open()">
                            Прочитал
                        </button>

                    </div>
                </div>
            </template>
        </v-modal-contents>
        <v-form ref="form" class="form_upload" v-model="valid" lazy-validation>
            <div class="row">
                <div class="col-12 col-md-12 py-0">
                    <div class="form_upload__item">
                        <label for="name" v-if="language == 'ru'">ФИО <span class="red"> *</span></label>
                        <label for="name" v-else-if="language == 'en'">Full name <span class="red"> *</span></label>
                        <v-text-field v-if="language == 'ru'"
                                      v-model="name"
                                      :rules="nameRulesRu"
                                      required=""
                                      solo
                                      id="name"
                        ></v-text-field>
                        <v-text-field v-else-if="language == 'en'"
                                      v-model="name"
                                      :rules="nameRules"
                                      required=""
                                      solo
                                      id="name"
                        ></v-text-field>

                    </div>
                </div>


                <div class="col-12 col-md-6 py-0">
                    <div class="form_upload__item item_tel position-relative">
                        <label for="tel">Телефон <span class="red"> *</span></label>
                        <v-text-field
                                v-model="tel_input"
                                :rules="tel_inputRulesRu"
                                required
                                solo
                                id="tel"
                                oninput="this.value = this.value.replace(/[^\d]/g,'');"
                                v-mask="'# ### ###-##-##'"
                                class="pl-0 "

                        ></v-text-field>


                        <!--            <v-select-->
                        <!--                :items="tel_items"-->
                        <!--                :menu-props="{ contentClass: 'wrap_selfilter' }"-->
                        <!--                item-value="sel_id"-->
                        <!--                v-model="defaultSelectedTel.sel_id"-->
                        <!--                solo-->
                        <!--                class="tel_sel__btn d-flex align-items-center"-->
                        <!--                append-icon="mdi mdi-chevron-down"-->
                        <!--            >-->
                        <!--              <template slot="selection" slot-scope="data">-->
                        <!--                <img :src="data.item.icon"></img>-->
                        <!--                <span class="tel_kod">{{ data.item.kod }}</span>-->
                        <!--              </template>-->

                        <!--              <template v-if="language == 'ru'" slot="item" slot-scope="data">-->
                        <!--                <img class="pr-2" :src="data.item.icon"></img>-->
                        <!--                <span>{{ data.item.name }}</span>-->
                        <!--              </template>-->
                        <!--              <template v-else-if="language == 'en'" slot="item" slot-scope="data">-->
                        <!--                <img class="pr-2" :src="data.item.icon"></img>-->
                        <!--                <span>{{ data.item.eng_name }}</span>-->
                        <!--              </template>-->
                        <!--            </v-select>-->

                    </div>
                </div>

                <div class="col-12 col-md-6 py-0">
                    <div class="form_upload__item">
                        <label for="email">E-mail <span class="red"> *</span></label>
                        <v-text-field v-if="language == 'ru'"
                                      v-model="email"
                                      :rules="emailRulesRu"
                                      required
                                      solo
                                      id="email"
                        ></v-text-field>
                        <v-text-field v-else-if="language == 'en'"
                                      v-model="email"
                                      :rules="emailRules"
                                      required
                                      solo
                                      id="email"
                        ></v-text-field>
                    </div>
                </div>


                <div class="col-12 col-md-6 py-0">
                    <div class="form_upload__item">
                        <label v-if="language == 'ru'" for="cuntry">Страна</label>
                        <label v-else-if="language == 'en'" for="cuntry">Country</label>
                        <v-select v-if="language == 'ru'"
                                  v-model="select_cuntry"
                                  :items="cuntryRu"
                                  solo
                                  id="cuntry"
                                  append-icon="mdi mdi-chevron-down"

                        ></v-select>
                        <v-select v-else-if="language == 'en'"
                                  v-model="select_cuntry"
                                  :items="cuntry"
                                  solo
                                  id="cuntry"
                                  append-icon="mdi mdi-chevron-down"

                        ></v-select>
                    </div>
                </div>


                <div class="col-12 col-md-6 py-0">
                    <div class="form_upload__item">
                        <label v-if="language == 'ru'" for="town">Город<span class="red"> *</span></label>
                        <label v-else-if="language == 'en'" for="town">City/town<span class="red"> *</span></label>
                        <v-text-field
                                v-model="town"
                                :rules="townRules"
                                solo
                                id="town"
                        ></v-text-field>
                    </div>
                </div>

                <div class="col-12 col-md-12 py-0">
                    <div class="form_upload__item">
                        <label v-if="language == 'ru'" for="position">Интересующая должность<span class="red"> *</span></label>
                        <v-text-field
                                v-model="position"
                                :rules="positionRules"
                                solo
                                id="position"
                        ></v-text-field>
                    </div>
                </div>

                <div class="col-12 col-md-12 py-0">
                    <div class="form_upload__item ">
                        <label v-if="language == 'ru'" for="summary">Резюме</label>
                        <label v-else-if="language == 'en'" for="summary">Resume</label>
                        <div
                                class="summary p-12 bg-gray-100 border border-gray-300 drag_form d-flex flex-column justify-content-center"
                                @dragover="dragover"
                                @dragleave="dragleave"
                                @drop="drop"
                                id="summary"
                        >
                            <input
                                    type="file"
                                    multiple
                                    name="fields[assetsFieldHandle][]"
                                    id="assetsFieldHandle"
                                    class="w-px h-px opacity-0 overflow-hidden absolute"
                                    @change="onChange"
                                    ref="file"
                                    accept=".pdf,.jpg,.jpeg,.png"
                            />

                            <label for="assetsFieldHandle" class="block cursor-pointer">
                                <div v-if="language == 'ru'">Выберите или перетащите сюда файл в формате PDF, DOC, DOCX,
                                    RTF, JPG
                                </div>
                                <div v-else-if="language == 'ru'">Choose or drag and drop here the file in formatss PDF,
                                    DOC, DOCX, RTF, JPG
                                </div>
                            </label>
                            <ul class="mt-4" v-if="this.filelist.length" v-cloak>
                                <li class="text-sm p-1 text-left" v-for="(file, index) in filelist" :key="index">
                                    {{ file.name }}
                                    <button
                                            class="ml-2 remove_file"
                                            type="button"
                                            @click="remove(filelist.indexOf(file))"
                                            title="Remove file"
                                    >
                                        remove
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-md-12 py-0">

                    <!-- SmartCaptcha -->
                    <div id="captcha-container" :class="captchaPassed ? '':'error-captcha'" class="w-100 mt-30"></div>

                    <div class="form_upload__item  mt-30">
                        <v-checkbox
                                v-model="checkbox"
                                :rules="[(v) => !!v || 'Это обязательный пункт']"
                                required
                                color="red"
                        >
                            <template v-slot:label>
                                <div class="customLabelForm">
                                    Я выражаю согласие с <a href="javascript:void(0);"
                                                            @click="$refs.modal_contents_agree.modal_open('scroll_false')">условиями
                                    использования</a> моих персональных данных для обработки данного обращения ООО «Компания Нова Ролл» (ИНН 5038050970, адрес: 141206, Московская область, г. Пушкино, Кудринское шоссе, д. 2а, стр. 5, этаж 2), я ознакомлен и выражаю согласие с
                                    <a :href="policy" class="position-relative zi-1" @click="linkOpen(policy)">Политикой
                                        конфиденциальности</a> и <a :href="agreement" @click="linkOpen(agreement)"
                                                                    class="position-relative zi-1">Пользовательским
                                    соглашением.</a>
                                </div>
                            </template>
                        </v-checkbox>

                        <!--            :rules="[(v) => !!v || 'Это обязательный пункт']"-->
                        <!--            required-->
                        <v-checkbox
                                v-model="consentToInform"

                                color="red"
                                class="mt-0"
                        >
                            <template v-slot:label>
                                <div class="customLabelForm">
                                    Я выражаю согласие на информирование меня о продуктах, акциях, выгодных
                                    предложениях, новостях ООО «Компания Нова Ролл» (ИНН 5038050970, адрес: 141206, Московская область, г. Пушкино, Кудринское шоссе, д. 2а, стр. 5, этаж 2) и
                                    партнеров.
                                </div>
                            </template>
                        </v-checkbox>

                        <div class="btn_form d-flex align-items-center justify-content-end ">
                            <v-btn v-if="language == 'ru'" :disabled="!valid" class="px-30 btn_red w-mc"
                                   @click="sendForm">
                                Отправить
                            </v-btn>

                            <!--            <v-btn color="error" class="mr-4" @click="reset"> Reset Form</v-btn>-->

                            <!--            <v-btn color="warning" @click="resetValidation"> Reset Validation</v-btn>-->
                        </div>
                    </div>

                </div>


            </div>

        </v-form>
    </div>

</template>
<script>
import VModalContents from "./modal_contents";
import {mask} from 'vue-the-mask';

export default {
    components: {
        VModalContents: VModalContents,
    },
    directives: {mask},
    name: "form_upload",
    props: {
        lang: Array | String | Number | Boolean | Object,
        policy: String | Boolean,
        agreement: String | Boolean,
        terms: String | Boolean,
    },
    delimiters: ["${", "}"], // Avoid Twig conflicts
    data() {
        return {
            captchaPassed: false,
            valid: true,

            language: this.lang,

            name: "",
            nameRules: [
                (v) => !!v || "Name is required",
                (v) => (v && v.length >= 3) || "Name must be less than 10 characters",
            ],

            nameRulesRu: [
                (v) => !!v || "Поле 'ФИО' не может быть пустым",
                (v) => (v && v.length >= 3) || "Поле 'ФИО' не может быть меньше 3 символов",
            ],

            email: "",
            emailRules: [
                (v) => !!v || "E-mail is required",
                (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
            ],

            emailRulesRu: [
                (v) => !!v || "E-mail обязателен",
                (v) => /.+@.+\..+/.test(v) || "E-mail заполнен неправильно",
            ],

            town: "",
            townRules: [
                (v) => !!v || "Город обязателен",
            ],

            position: "",
            positionRules: [
                (v) => !!v || "Должность обязательна",
            ],

            select_cuntry: null,
            cuntryRu: ["Россия", "Казахстан"],
            cuntry: ["Russia", "Kazakhstan"],
            // cuntryRu: ["Россия", "Польша", "Казахстан"],
            //   cuntry: ["Russia", "Poland", "Kazakhstan"],


            tel_select: null,
            tel_items: [
                {
                    sel_id: 0,
                    name: "Россия",
                    eng_name: "Russia",
                    icon: "/local/templates/international/img/FlagRossii.svg",
                    kod: "+7",
                },
                // {
                //   sel_id: 1,
                //   name: "Польша",
                //   eng_name: "Poland",
                //   icon: "/local/templates/international/img/FlagPaulshi.svg",
                //   kod: "+2",
                // },
                {
                    sel_id: 1,
                    name: "Казахстан",
                    icon: "/local/templates/international/img/FlagKazakhstana.svg",
                    kod: "+7",
                },
            ],

            defaultSelectedTel: {
                sel_id: 0,
            },

            tel_input: "",
            // tel_inputRules: [
            //   (v) => !!v || "Phone is required",
            //   (v) => /^[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}/.test(v) || "Phone must be valid",
            // ],

            // tel_inputRulesRu: [
            //   (v) => !!v || "Поле 'Телефон' обязательно к заполнению",
            //   (v) => /^\(\d{3}\) \d{3}-\d{2}-\d{2}$/.test(v) || "Поле 'Телефон' заполнено неправильно",
            // ],
            tel_inputRulesRu: [
                (v) => !!v || "Поле 'Телефон' обязательно для заполнения",
                // (v) => /^\(\d{3}\) \d{3}-\d{2}-\d{2}$/.test(v) || "Телефон заполнен неправильно",
                // (v) => /^[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}/.test(v) || "Телефон заполнен неправильно",
            ],
            checkbox: false,
            consentToInform: false,
            // upload drag-and-drop file
            filelist: [],
        };
    },

    methods: {
        linkOpen(url) {
            window.open(url, '_blank');
        },
        // Captcha
        initCaptcha() {
            window.smartCaptcha.render('captcha-container', {
                sitekey: 'ysc1_PUekBeYtvyneoIe4lOZeV4coxdETZmtFUf5aFClW81ba7cd1',
                callback: this.onCaptchaSuccess,
            });
        },
        onCaptchaSuccess(token) {
            this.captchaPassed = true;
            this.form.captchaToken = token;
        },
        // Captcha end
        sendForm() {
            if (!this.$refs.form.validate()) return false;
            if (!this.captchaPassed) {
                this.valid = false;
                return false;
            } else {
                this.valid = true;
            }

            /** AJAX */
            var VueObject = this;
            var formData = new FormData();
            $.each(VueObject.filelist, function (key, value) {
                formData.append(key, value);
            });

            let newTel = VueObject.tel_input;
            if (newTel[0] === '7') {
                newTel = "+ " + newTel; // если первая цифра 7, добавляем +
            }
            console.log(newTel);

            formData.append("name", VueObject.name);
            formData.append("phone", newTel);
            formData.append("email", VueObject.email);
            formData.append("country", VueObject.select_cuntry);
            formData.append("town", VueObject.town);
            formData.append("position", VueObject.position);
            formData.append("ajaxPost", "Y");
            $.ajax({
                "type": "POST",
                "url": "/ajax/career_form.php",
                "data": formData,
                "cache": false,
                "dataType": 'json',
                "processData": false, // Не обрабатываем файлы (Don't process the files)
                "contentType": false, // Так jQuery скажет серверу что это строковой запрос
                "success": function (res) {
                    console.log(res);
                    $(".text_result").slideDown(300);
                    $(".text_result").delay(3000).slideUp(300);
                    VueObject.reset();
                    // setTimeout(() => {window.location.reload();}, 3000);
                },
                "error": function (xhr, ajaxOptions, thrownError) {
                    console.log(xhr.status);
                    console.log(thrownError);
                },
            });
        },
        reset() {
            this.$refs.form.reset();
        },
        resetValidation() {
            this.$refs.form.resetValidation();
        },

        // upload drag-and-drop file

        onChange() {
            this.filelist = [...this.$refs.file.files];
        },
        remove(i) {
            this.filelist.splice(i, 1);
        },
        dragover(event) {
            event.preventDefault();
            // Add some visual fluff to show the user can drop its files
            if (!event.currentTarget.classList.contains("bg-green-300")) {
                event.currentTarget.classList.remove("bg-gray-100");
                event.currentTarget.classList.add("bg-green-300");
            }
        },
        dragleave(event) {
            // Clean up
            event.currentTarget.classList.add("bg-gray-100");
            event.currentTarget.classList.remove("bg-green-300");
        },
        drop(event) {
            event.preventDefault();
            this.$refs.file.files = event.dataTransfer.files;
            this.onChange(); // Trigger the onChange event manually
            // Clean up
            event.currentTarget.classList.add("bg-gray-100");
            event.currentTarget.classList.remove("bg-green-300");
        },

        // upload drag-and-drop file end
    },
    watch: {
        captchaPassed() {
            // this.sendForm();
            if (!this.captchaPassed) {
                this.valid = false;
                return false;
            } else {
                this.valid = true;
            }
        },
    },
    created() {
        setTimeout(() => {
            this.initCaptcha();
        }, 500);

    },

};
</script>


<style lang="scss">
@import "../../theme/_variable.scss";

#assetsFieldHandle,
[v-cloak] {
  display: none;
}

.terms_of_use {
  overflow-y: scroll;
    max-height: 50vh;
}

.form_upload {


  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
    border: 1px solid #E2E2E2;
    box-sizing: border-box;
    border-radius: 10px;
    box-shadow: 0px 1.5px 4px -1px #0A090B12;

  }

  .theme--light.v-btn.v-btn--has-bg {
    background-color: #d50f0f;
    width: 100%;
  }

  & .remove_file {
    color: red;
  }

  & .v-input--checkbox {
    & label {
      margin-bottom: 0;
    }
  }

  & .form_upload__item {
    & label {
      font-family: $font-Museo500;
      font-style: normal;
      font-weight: normal;
      font-size: 20px;
      line-height: 100%;
      display: flex;
      align-items: center;
      color: #3A3A3A;
      mix-blend-mode: normal;

      & span {
        padding-left: 5px;
      }
    }

    & .v-btn__content {

    }
  }

  & .form_upload__item {
    & .summary {
      & label {
        font-family: $RobotoRegular;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 120%;
        align-items: center;
        color: #000000;
        opacity: 0.7;
        width: 100%;
        margin: auto;
        height: 100%;
        padding: 40px 21px;
        justify-content: center;

      }
    }

  }

  & .tel_input {
    & .v-input__slot {
      font-family: $RobotoRegular;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 160%;
      padding-left: 87px !important;
      padding-top: 1px !important;
    }
  }

  & .tel_sel__btn {
    width: max-content;
    height: 0;
    position: absolute;
    top: 62px;
    background: none;
    margin-left: 15px !important;

    & .v-input__slot {
      margin: 0;
      box-shadow: none !important;
      border: none !important;
      padding: 0 !important;
      width: 70px;
      background: none !important;
    }

    & .tel_kod {
      margin-left: 23px;
      position: relative;
      margin-top: 2px;
      font-family: $RobotoRegular;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 160%;
      color: #BDBDBD;
    }

    & .v-input__append-inner {
      margin-right: 21px;
      padding-left: 0;
      margin-top: 3px !important;

      i {
        color: #BDBDBD;
      }
    }

  }
}
</style>

<style lang="scss" scoped>


.drag_form {
  background: rgba(249, 66, 55, 0.06);
  border: 1px dashed #f94237 !important;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "RobotoRegular";
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 120%;
  display: flex;
  align-items: center;
  color: #000000;
  opacity: 0.7;
  text-align: center;

}

</style>